import styled, { createGlobalStyle } from 'styled-components';
import { Link } from 'react-router-dom';
import { techColors, neonGlow, alpha, dangerButtonHoverStyles, THEME_PALETTES } from './TechRetroEffects';

const paletteToCss = (palette) => Object.entries(palette)
  .map(([name, value]) => `${name}: ${value};`)
  .join('\n    ');

export const GlobalStyle = createGlobalStyle`
  /* Значения палитры по умолчанию — тёмная тема */
  :root {
    ${paletteToCss(THEME_PALETTES.dark)}
    color-scheme: dark;
  }

  :root[data-theme='light'] {
    ${paletteToCss(THEME_PALETTES.light)}
    color-scheme: light;
  }

  * {
    font-family: 'JetBrains Mono', monospace;
    box-sizing: border-box;
  }

  html, body {
    height: 100%;
    margin: 0;
    overflow-x: hidden;
    font-size: 13px;
    background: ${techColors.darkBg};
    color: ${techColors.textPrimary};
    transition: background-color 0.25s ease, color 0.25s ease;
    -webkit-text-size-adjust: 100%;
    touch-action: manipulation;
  }

  #root {
    min-height: 100%;
    min-height: 100dvh;
    overflow-y: auto;
    background: ${techColors.darkBg};
  }

  /* Стилизация скроллбаров в техно-ретро стиле */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${techColors.darkBg};
    border: 1px solid ${alpha(techColors.neonCyan, '30')};
  }

  ::-webkit-scrollbar-thumb {
    background: ${alpha(techColors.neonCyan, '60')};
    border: 1px solid ${techColors.neonCyan};
    box-shadow: 0 0 5px ${alpha(techColors.neonCyan, '40')};
    
    &:hover {
      background: ${techColors.neonCyan};
      box-shadow: 0 0 10px ${alpha(techColors.neonCyan, '60')};
    }
  }

  /* Медиа-запросы для адаптивности */
  @media (max-width: 768px) {
    html {
      font-size: 12px;
    }
  }

  @media (max-width: 480px) {
    html {
      font-size: 11px;
    }
  }
`;



//БОКОВОЕ МЕНЮ
export const DropdownMenuAnchor = styled.div`
  position: relative;
  flex-shrink: 0;
`;

export const DropdownItem = styled(Link)`
  display: block;
  color: ${techColors.textPrimary};
  padding: 12px 18px;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.3;
  transition: background-color 0.2s ease, color 0.2s ease;
  text-align: left;
  white-space: nowrap;
  border: none;
  background: transparent;

  &:hover {
    background: ${techColors.darkBgTertiary};
    color: ${techColors.textPrimary};
  }

  &:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  &:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

export const LogoutButton = styled.button`
  display: block;
  color: ${techColors.danger};
  padding: 12px 18px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.3;
  font-weight: 500;
  text-align: left;
  transition: all 0.3s ease;
  width: 100%;
  white-space: nowrap;

  &:hover {
    background: ${techColors.darkBgTertiary};
    color: ${techColors.danger};
    ${dangerButtonHoverStyles}
  }

  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;

export const MenuButton = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== '$open',
})`
  position: fixed;
  top: max(14px, env(safe-area-inset-top));
  right: max(28px, env(safe-area-inset-right));
  width: 56px;
  height: 56px;
  border-radius: 4px;
  border: 1px solid ${techColors.borderSubtle};
  background: ${techColors.darkBgTertiary};
  color: ${techColors.textPrimary};
  font-size: 1.5em;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ $open }) => ($open ? 1 : 0.7)};
  transition: background-color 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  z-index: 200;

  &:hover {
    opacity: 1;
    background: ${techColors.darkBg};
    ${neonGlow(techColors.neonCyan, 'normal')}
  }

  @media (max-width: 768px) {
    top: max(8px, env(safe-area-inset-top));
    right: max(10px, env(safe-area-inset-right));
    width: 44px;
    height: 44px;
    font-size: 1.05em;
  }
`;

export const RequestsBadge = styled.button`
  position: fixed;
  top: max(22px, calc(env(safe-area-inset-top) + 8px));
  right: 94px;
  z-index: 101;
  border: 1px solid ${techColors.neonCyan};
  background: ${techColors.darkBgSecondary};
  color: ${techColors.neonCyan};
  font-size: 0.75em;
  font-weight: 600;
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 0 10px ${alpha(techColors.neonCyan, '40')};
  transition: all 0.2s ease;

  &:hover {
    background: ${techColors.darkBgTertiary};
    box-shadow: 0 0 15px ${alpha(techColors.neonCyan, '60')};
    transform: scale(1.03);
  }

  @media (max-width: 768px) {
    top: max(10px, calc(env(safe-area-inset-top) + 4px));
    right: 62px;
    font-size: 0.7em;
    padding: 5px 8px;
  }
`;

export const DropdownMenu = styled.div`
  position: fixed;
  top: calc(78px + env(safe-area-inset-top));
  right: max(28px, env(safe-area-inset-right));
  background: ${techColors.darkBgSecondary};
  border: 1px solid ${techColors.borderSubtle};
  border-radius: 4px;
  padding: 6px 0;
  display: flex;
  flex-direction: column;
  visibility: ${({ open }) => (open ? 'visible' : 'hidden')};
  opacity: ${({ open }) => (open ? 1 : 0)};
  z-index: 201;
  width: auto;
  min-width: 180px;
  transform: ${({ open }) => (open ? 'translateY(0)' : 'translateY(-6px)')};
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s ease;
  pointer-events: ${({ open }) => (open ? 'auto' : 'none')};
  box-shadow: none;

  @media (max-width: 768px) {
    top: calc(60px + env(safe-area-inset-top));
    right: max(10px, env(safe-area-inset-right));
    min-width: 190px;
  }
`;
